import { useQuery } from "@tanstack/react-query";

import { getAttendance } from "@/adapters/api";
import { chartKeys } from "../utils/query-keys.ts";

const STALE_TIME = 60_000;

export interface UseAttendanceParams {
	worksiteId: string | undefined;
	referenceDate: string;
	enabled?: boolean;
}

export function useAttendance({
	worksiteId,
	referenceDate,
	enabled = true,
}: UseAttendanceParams) {
	return useQuery({
		queryKey: chartKeys.attendance(worksiteId, referenceDate),
		queryFn: () =>
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			getAttendance(worksiteId!, { referenceDate }),
		enabled: enabled && !!worksiteId,
		staleTime: STALE_TIME,
	});
}
